import {
  FETCH_STARTER_KIT_PURCHASES_REQUEST,
  FETCH_STARTER_KIT_PURCHASES_SUCCESS,
  FETCH_STARTER_KIT_PURCHASES_FAILURE,

  FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST,
  FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS,
  FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE,

  UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST,
  UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS,
  UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE,
} from "./types";

import {
  fetchStarterKitPurchases,
  fetchStarterKitPaymentProofs,
  updateStarterKitPaymentProof,
} from "../../services/starterKitPurchaseService";


export const fetchStarterKitPurchasesRequest = () => ({
  type: FETCH_STARTER_KIT_PURCHASES_REQUEST,
});

export const fetchStarterKitPurchasesSuccess = (
  purchases
) => ({
  type: FETCH_STARTER_KIT_PURCHASES_SUCCESS,
  payload: purchases,
});

export const fetchStarterKitPurchasesFailure = (
  error
) => ({
  type: FETCH_STARTER_KIT_PURCHASES_FAILURE,
  payload: error,
});



export const fetchStarterKitPaymentProofsRequest = () => ({
  type: FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST,
});

export const fetchStarterKitPaymentProofsSuccess = (
  proofs
) => ({
  type: FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS,
  payload: proofs,
});

export const fetchStarterKitPaymentProofsFailure = (
  error
) => ({
  type: FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE,
  payload: error,
});



export const updateStarterKitPaymentProofRequest = () => ({
  type: UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST,
});

export const updateStarterKitPaymentProofSuccess = (
  proof
) => ({
  type: UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS,
  payload: proof,
});

export const updateStarterKitPaymentProofFailure = (
  error
) => ({
  type: UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE,
  payload: error,
});



export const fetchStarterKitPurchasesAction =
  (
    page = 1,
    size = 10
  ) =>
  async (dispatch) => {

    dispatch(
      fetchStarterKitPurchasesRequest()
    );

    try {

      const response =
        await fetchStarterKitPurchases(
          page,
          size
        );

      if (response.success) {

        dispatch(
          fetchStarterKitPurchasesSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      }

      dispatch(
        fetchStarterKitPurchasesFailure(
          response.error
        )
      );

      return {
        success: false,
        error: response.error,
      };

    } catch (error) {

      const message =
        error.message ||
        "Failed to fetch Starter Kit Purchases";

      dispatch(
        fetchStarterKitPurchasesFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };



export const fetchStarterKitPaymentProofsAction =
  (
    page = 1,
    size = 10
  ) =>
  async (dispatch) => {

    dispatch(
      fetchStarterKitPaymentProofsRequest()
    );

    try {

      const response =
        await fetchStarterKitPaymentProofs(
          page,
          size
        );

      if (response.success) {

        dispatch(
          fetchStarterKitPaymentProofsSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      }

      dispatch(
        fetchStarterKitPaymentProofsFailure(
          response.error
        )
      );

      return {
        success: false,
        error: response.error,
      };

    } catch (error) {

      const message =
        error.message ||
        "Failed to fetch Starter Kit Payment Proofs";

      dispatch(
        fetchStarterKitPaymentProofsFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };



export const updateStarterKitPaymentProofAction =
  (
    paymentId,
    status,
    statusReason
  ) =>
  async (dispatch) => {

    dispatch(
      updateStarterKitPaymentProofRequest()
    );

    try {

      const response =
        await updateStarterKitPaymentProof(
          paymentId,
          status,
          statusReason
        );

      if (response.success) {

        dispatch(
          updateStarterKitPaymentProofSuccess(
            response.data
          )
        );

        return {
          success: true,
          data: response.data,
        };

      }

      dispatch(
        updateStarterKitPaymentProofFailure(
          response.error
        )
      );

      return {
        success: false,
        error: response.error,
      };

    } catch (error) {

      const message =
        error.message ||
        "Failed to update Starter Kit Payment Proof";

      dispatch(
        updateStarterKitPaymentProofFailure(
          message
        )
      );

      return {
        success: false,
        error: message,
      };
    }
  };